import { Product } from '../types';

// ============================================
// SPECIAL UNIVERSAL CONNECTORS - 5 & 6 POLE
// ============================================

// 5 POLE SPECIAL CONNECTORS
export const specialConnector5PoleProducts: Product[] = [
  {
    id: "special-conn-5p-f-5mm-ecm",
    name: "Universal 5 Pole Female - 5mm Wire & ECM",
    slug: "special-universal-5-pole-female-5mm-ecm",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with 5mm deluxe wire and ECM wire.",
    partNumber: "SH2100527",
    image: "/products/special-universal-connectors/special-universal/SH2100527.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "5mm Deluxe & ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-5p-f-5mm-ecm-2",
    name: "Universal 5 Pole Female - 5mm Deluxe & ECM Wire",
    slug: "special-universal-5-pole-female-5mm-ecm-2",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with 5mm deluxe and ECM wire.",
    partNumber: "SH2100529",
    image: "/products/special-universal-connectors/special-universal/SH2100529.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "5mm Deluxe & ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-tata-ace-5p-f",
    name: "Tata Ace 5 Pole Female",
    slug: "special-tata-ace-5-pole-female",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Tata Ace 5 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100531",
    image: "/products/special-universal-connectors/special-universal/SH2100531.jpg",
    featured: true,
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Tata Ace",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "tata", "ace", "female"],
    applications: ["Tata Ace"],
  },
  {
    id: "special-conn-wiper-motor-tata-5p-f",
    name: "Wiper Motor Tata 5 Pole Female",
    slug: "special-wiper-motor-tata-5-pole-female",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Wiper motor for Tata 5 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100533",
    image: "/products/special-universal-connectors/special-universal/SH2100533.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Tata Wiper Motor",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "tata", "wiper-motor", "female"],
    applications: ["Tata Wiper Motor"],
  },
  {
    id: "special-conn-al-wiper-pin-tata-5p-f",
    name: "Universal Ashok Leyland Wiper Pin/Tata 5 Pole Female",
    slug: "special-al-wiper-pin-tata-5-pole-female",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal Ashok Leyland wiper pin/Tata 5 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100550",
    image: "/products/special-universal-connectors/special-universal/SH2100550.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland Wiper Pin, Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "ashok-leyland", "tata", "wiper-pin", "female"],
    applications: ["Ashok Leyland", "Tata", "Wiper Pin"],
  },
  {
    id: "special-conn-al-5p-f-4mm",
    name: "Ashok Leyland 5 Pole Female - 4mm Wire",
    slug: "special-al-5-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Ashok Leyland 5 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100563",
    image: "/products/special-universal-connectors/special-universal/SH2100563.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-new-model-5p-f-5mm",
    name: "Ashok Leyland New Model 5 Pole Female - 5mm Wire",
    slug: "special-al-new-model-5-pole-female-5mm",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Ashok Leyland new model 5 pole female connector with 5mm deluxe wire.",
    partNumber: "SH2100571",
    image: "/products/special-universal-connectors/special-universal/SH2100571.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland New Model",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "ashok-leyland", "new-model", "female"],
    applications: ["Ashok Leyland New Model"],
  },
  {
    id: "special-conn-universal-5p-f-ecm",
    name: "Universal 5 Pole Female - ECM Special Wire",
    slug: "special-universal-5-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with ECM special wire.",
    partNumber: "SH2100575",
    image: "/products/special-universal-connectors/special-universal/SH2100575.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-universal-5p-f-special",
    name: "Universal 5 Pole Female - Special Wire",
    slug: "special-universal-5-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with special wire.",
    partNumber: "SH2100579",
    image: "/products/special-universal-connectors/special-universal/SH2100579.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-universal-5p-f-ecm-2",
    name: "Universal 5 Pole Female - ECM Wire",
    slug: "special-universal-5-pole-female-ecm-2",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with ECM wire.",
    partNumber: "SH2100580",
    image: "/products/special-universal-connectors/special-universal/SH2100580.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-al-5p-f-special",
    name: "Ashok Leyland 5 Pole Female - Special Wire",
    slug: "special-al-5-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Ashok Leyland 5 pole female connector with special wire.",
    partNumber: "SH2100581",
    image: "/products/special-universal-connectors/special-universal/SH2100581.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-5p-f-ecm-3",
    name: "Universal 5 Pole Female - ECM Wire (Type 3)",
    slug: "special-universal-5-pole-female-ecm-3",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Universal 5 pole female connector with ECM wire.",
    partNumber: "SH2100582",
    image: "/products/special-universal-connectors/special-universal/SH2100582.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "universal", "ecm", "female"],
    applications: ["Universal Applications", "ECM"],
  },
  {
    id: "special-conn-al-5p-m-special",
    name: "Ashok Leyland 5 Pole Male - Special Wire",
    slug: "special-al-5-pole-male-special",
    category: "Special Universal Connectors",
    subcategory: "5 Pole Connectors",
    description: "Ashok Leyland 5 pole male connector with special wire.",
    partNumber: "SH2100583",
    image: "/products/special-universal-connectors/special-universal/SH2100583.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Male",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "5-pole", "ashok-leyland", "male"],
    applications: ["Ashok Leyland"],
  },
];

// 6 POLE SPECIAL CONNECTORS
export const specialConnector6PoleProducts: Product[] = [
  {
    id: "special-conn-tail-light-tata-6p-f",
    name: "Tail Light Tata 6 Pole Female",
    slug: "special-tail-light-tata-6-pole-female",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Tail light for Tata 6 pole female connector with special wire.",
    partNumber: "SH2100621",
    image: "/products/special-universal-connectors/special-universal/SH2100621.jpg",
    featured: true,
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Tata Tail Light",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "tata", "tail-light", "female"],
    applications: ["Tata Tail Light"],
  },
  {
    id: "special-conn-al-6p-f-special",
    name: "Universal Ashok Leyland 6 Pole Female - Special Wire",
    slug: "special-universal-al-6-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal Ashok Leyland 6 pole female connector with special wire.",
    partNumber: "SH2100637",
    image: "/products/special-universal-connectors/special-universal/SH2100637.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Universal Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-maximo-6p-f-4mm",
    name: "Mahindra Maximo 6 Pole Female - 4mm Wire",
    slug: "special-maximo-6-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Mahindra Maximo 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100641",
    image: "/products/special-universal-connectors/special-universal/SH2100641.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "maximo", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-universal-tata-6p-f-4mm",
    name: "Universal Tata 6 Pole Female - 4mm Wire",
    slug: "special-universal-tata-6-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal Tata 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100643",
    image: "/products/special-universal-connectors/special-universal/SH2100643.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-6p-f-special",
    name: "Universal Tata 6 Pole Female - Special Wire",
    slug: "special-universal-tata-6-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal Tata 6 pole female connector with special wire.",
    partNumber: "SH2100645",
    image: "/products/special-universal-connectors/special-universal/SH2100645.jpg",
    featured: true,
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-6p-f-4mm-2",
    name: "Universal Tata 6 Pole Female - 4mm Wire (Type 2)",
    slug: "special-universal-tata-6-pole-female-4mm-2",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal Tata 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100647",
    image: "/products/special-universal-connectors/special-universal/SH2100647.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-universal-tata-6p-f-4mm-3",
    name: "Universal Tata 6 Pole Female - 4mm Wire (Type 3)",
    slug: "special-universal-tata-6-pole-female-4mm-3",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal Tata 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100650",
    image: "/products/special-universal-connectors/special-universal/SH2100650.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Universal Tata",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles"],
  },
  {
    id: "special-conn-eicher-valve-6p-f",
    name: "Eicher Valve 6 Pole Female",
    slug: "special-eicher-valve-6-pole-female",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Eicher valve 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100651",
    image: "/products/special-universal-connectors/special-universal/SH2100651.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Eicher Valve",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "eicher", "valve", "female"],
    applications: ["Eicher Valve"],
  },
  {
    id: "special-conn-al-6p-f-4mm",
    name: "Ashok Leyland 6 Pole Female - 4mm Wire",
    slug: "special-al-6-pole-female-4mm",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Ashok Leyland 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100652",
    image: "/products/special-universal-connectors/special-universal/SH2100652.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-skoda-maximo-6p-f-special",
    name: "Skoda/Mahindra Maximo 6 Pole Female - Special Wire",
    slug: "special-skoda-maximo-6-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Skoda/Mahindra Maximo 6 pole female connector with special wire.",
    partNumber: "SH2100653",
    image: "/products/special-universal-connectors/special-universal/SH2100653.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Skoda, Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "skoda", "maximo", "female"],
    applications: ["Skoda", "Mahindra Maximo"],
  },
  {
    id: "special-conn-tata-air-filter-6p-f",
    name: "Tata Air Filter 6 Pole Female",
    slug: "special-tata-air-filter-6-pole-female",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Tata air filter 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SH2100656",
    image: "/products/special-universal-connectors/special-universal/SH2100656.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Tata Air Filter",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "tata", "air-filter", "female"],
    applications: ["Tata Air Filter"],
  },
  {
    id: "special-conn-maximo-side-cut-6p-f",
    name: "Mahindra Maximo Side Cut 6 Pole Female",
    slug: "special-maximo-side-cut-6-pole-female",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Mahindra Maximo side cut 6 pole female connector with special wire.",
    partNumber: "SH2100658",
    image: "/products/special-universal-connectors/special-universal/SH2100658.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo Side Cut",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "maximo", "side-cut", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-maximo-d-cut-6p-f",
    name: "Mahindra Maximo D Cut 6 Pole Female",
    slug: "special-maximo-d-cut-6-pole-female",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Mahindra Maximo D cut 6 pole female connector with special wire.",
    partNumber: "SH2100660",
    image: "/products/special-universal-connectors/special-universal/SH2100660.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo D Cut",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "maximo", "d-cut", "female"],
    applications: ["Mahindra Maximo"],
  },
  {
    id: "special-conn-skoda-maximo-6p-f-special-2",
    name: "Skoda/Mahindra Maximo 6 Pole Female - Special Wire (Type 2)",
    slug: "special-skoda-maximo-6-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Skoda/Mahindra Maximo 6 pole female connector with special wire.",
    partNumber: "SH2100662",
    image: "/products/special-universal-connectors/special-universal/SH2100662.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Skoda, Mahindra Maximo",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "skoda", "maximo", "female"],
    applications: ["Skoda", "Mahindra Maximo"],
  },
  {
    id: "special-conn-skoda-maximo-6p-f-ecm",
    name: "Skoda/Mahindra Maximo 6 Pole Female - ECM Wire",
    slug: "special-skoda-maximo-6-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Skoda/Mahindra Maximo 6 pole female connector with ECM wire.",
    partNumber: "SH2100664",
    image: "/products/special-universal-connectors/special-universal/SH2100664.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Skoda, Mahindra Maximo",
      "Wire Type": "ECM Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "skoda", "maximo", "ecm", "female"],
    applications: ["Skoda", "Mahindra Maximo", "ECM"],
  },
  {
    id: "special-conn-al-6p-f-special-2",
    name: "Ashok Leyland 6 Pole Female - Special Wire",
    slug: "special-al-6-pole-female-special",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Ashok Leyland 6 pole female connector with special wire.",
    partNumber: "SH2100666",
    image: "/products/special-universal-connectors/special-universal/SH2100666.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-universal-2p-f-special-misc",
    name: "Universal 2 Pole Female - Special Wire",
    slug: "special-universal-2-pole-female-special-misc",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Universal 2 pole female connector with special wire.",
    partNumber: "SH2100668",
    image: "/products/special-universal-connectors/special-universal/SH2100668.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "2-pole", "universal", "female"],
    applications: ["Universal Applications"],
  },
  {
    id: "special-conn-al-6p-f-special-3",
    name: "Ashok Leyland 6 Pole Female - Special Wire (Type 2)",
    slug: "special-al-6-pole-female-special-2",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Ashok Leyland 6 pole female connector with special wire.",
    partNumber: "SH2100680",
    image: "/products/special-universal-connectors/special-universal/SH2100680.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "ashok-leyland", "female"],
    applications: ["Ashok Leyland"],
  },
  {
    id: "special-conn-al-6p-f-ecm",
    name: "Ashok Leyland 6 Pole Female - ECM Special Wire",
    slug: "special-al-6-pole-female-ecm",
    category: "Special Universal Connectors",
    subcategory: "6 Pole Connectors",
    description: "Ashok Leyland 6 pole female connector with ECM special wire.",
    partNumber: "SH2100682",
    image: "/products/special-universal-connectors/special-universal/SH2100682.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "Ashok Leyland",
      "Wire Type": "ECM Special Wire",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["special-connector", "6-pole", "ashok-leyland", "ecm", "female"],
    applications: ["Ashok Leyland", "ECM"],
  },
];
